<p class="noCriteria"[i18nKey]="'evaluations.customer.satisfaction.criteria.no.parameters.explanation'"></p>

<div class="evaluationExplanation">
    <div class="evaluationExplanation-item"
         [innerHTML]="'evaluations.customer.satisfaction.criteria.mark.depending.on.quality'|translate" [i18nKey]="[{target: 'innerHTML', key: 'evaluations.customer.satisfaction.criteria.mark.depending.on.quality'}]">
    </div>
    <div class="evaluationExplanation-item"
         [innerHTML]="'evaluations.customer.satisfaction.criteria.quality.compared.to.standing'|translate" [i18nKey]="[{target: 'innerHTML', key: 'evaluations.customer.satisfaction.criteria.quality.compared.to.standing'}]">
    </div>
</div>

<kiwi-spacer [size]="16"></kiwi-spacer>

<p [innerHTML]="'evaluations.customer.satisfaction.criteria.maximum.explanation' | translate: {'linkToFinalMarkCriteria': 'evaluations/FINAL_MARK/criteria'}"></p>

<div class="noteExplanation">
    <span [i18nKey]="'evaluations.customer.satisfaction.criteria.formula.introduction'"></span>
    <br>
    <strong
        class="noteExplanation-formula"[i18nKey]="'evaluations.customer.satisfaction.criteria.formula'"></strong>
</div>

<kiwi-spacer [size]="8"></kiwi-spacer>

<p [i18nKey]="'evaluations.customer.satisfaction.criteria.formula.maximum'"></p>
